import * as _ from 'lodash';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WindowService } from 'services';

@Component({
    selector: 'fc-terms-of-use-pdf',
    templateUrl: './terms-of-use-pdf.component.html',
    styleUrls: ['./terms-of-use-pdf.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TermsOfUsePdfComponent implements OnInit {
    @Input() termsOfUse: string;

    public showPdfLink = false;

    constructor(private windowService: WindowService) {}

    ngOnInit() {
        this.showPdfLink = _.startsWith(this.termsOfUse, 'http') && _.endsWith(this.termsOfUse, '.pdf');
    }

    openTermsModal(event) {
        event.preventDefault();
        this.windowService.open(this.termsOfUse);
    }
}
